export interface RegionResponse {
  region: string;
}

export interface ApiResponse<T> {
  response: T;
}

export const getRegion = async (): Promise<ApiResponse<RegionResponse>> => {
  const response = await fetch(`/api/region`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Cache-Control": "no-cache, no-store, must-revalidate",
      Pragma: "no-cache",
    },
  });

  const payload = (await response.json()) as ApiResponse<RegionResponse>;

  if (!response.ok) {
    throw new Error("Error fetching region");
  }

  return payload;
};
